/**
 * Formats error response from booking API
 * @param {Error} error - Error object from API call
 * @returns {Object} Formatted error object with error message
 */
export const formatBookingError = (error) => {
  if (error?.code === 'ERR_NETWORK') {
    return { shouldPoll: true, error: 'ERR_NETWORK' };
  }

  if (error?.response?.status === 406) {
    const { data } = error.response;

    if (data.clientOverwriteWarning) {
      return {
        clientOverwriteWarning: data.clientOverwriteWarning,
      };
    }

    let errorText = 'Your trip availability/price is changed!';

    if (data.isFareUnavailable) {
      errorText = 'Fare is not available. Contact airdesk for issues related to flight booking.';
    } else if (data.isPriceQuoteChanged) {
      errorText = 'Flight price has changed. Contact airdesk for issues related to flight booking.';
    }

    return {
      tripData: data.trip
        ? {
            trip: {
              ...(data.trip || {}),
              maxCharsNoteToAirDesk: data.maxCharsNoteToAirDesk,
              doShowNoteToAirDeskInput: data.doShowNoteToAirDeskInput,
              doShowCompanyNameInput: data.doShowCompanyNameInput,
              doShowAgencyPlanningFeesPerPassenger: data.doShowAgencyPlanningFeesPerPassenger,
              separatePnrForTravelTypes: data.separatePnrForTravelTypes,
              doSupportsCardUpsertOperations: data.doSupportsCardUpsertOperations,
              tripBookingFees: data.tripBookingFees,
            },
          }
        : null,
      error: errorText,
      isTripAvailabilityPriceChanged: true,
      tripAvailabilityPriceChangeResponse: data,
    };
  }

  if (error?.response?.data) {
    let errorMessage = '';

    if (error.response.data.errors && typeof error.response.data.errors === 'object') {
      errorMessage = Object.entries(error.response.data.errors)
        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
        .join('\n');
    }

    return {
      error: `${error.response.data.title || ''} ${errorMessage || error.response.data.detail || ''}`,
    };
  }

  if (error && typeof error === 'object' && error.message) {
    return {
      error: `There is problem with booking trip. ${error.name}: ${error.message} (${error.code}). please contact support.`,
    };
  }

  return {
    error: 'There is problem with booking trip. please contact support.',
  };
};

export default formatBookingError;
